let intransfer = {};

intransfer.compass = {
	toViewMeetings: async () => {
		window.location = `/TransferTo?target_fuseaction=view_meetings`;
	},
	toEditMeeting: async (meeting_id) =>  {
		window.location = `/TransferTo?target_fuseaction=edit_meeting&meeting_id=${meeting_id}`;
	},
	toMeetingHotelDetails: async (meeting_id, meeting_hotel_id) => {
		window.location = `/TransferTo?target_fuseaction=edit_meeting_hotel_details&Meeting_hotel_id=${meeting_hotel_id}&meeting_id=${meeting_id}`;
	},
	toEditMeetingHotel: async (meeting_id) =>  {
		window.location = `/TransferTo?target_fuseaction=edit_meeting_hotel&meeting_id=${meeting_id}`;
	},
	toBlockBuilder: async (meeting_id, meeting_hotel_id) => {
		window.location = `/TransferTo?target_fuseaction=block_builder&Meeting_ID=${meeting_id}&Meeting_hotel_id=${meeting_hotel_id}`;
	},
	toExternalServices: async (meeting_id) => {
		window.location = `/TransferTo?target_fuseaction=edit_external_services&meeting_id=${meeting_id}`;
	},
	toCategories: async (meeting_id) => {
		window.location = `/TransferTo?target_fuseaction=edit_categories&Meeting_ID=${meeting_id}`;
	},
	toEditMeetingSite: async (site_id) =>  {
		window.location = `/TransferTo?target_fuseaction=edit_meeting_site&site_id=${site_id}`;
	},
	toViewMeetingSites: async () =>  {
		window.location = `/TransferTo?target_fuseaction=view_meeting_sites`;
	},
	toReports: async () =>  {
		window.location = `/TransferTo?target_fuseaction=reports`;
	},
	toDataMiner: async (routine_url) =>  {
		window.location = `/TransferTo?target_fuseaction=routine_display&Routine_Url=${routine_url}`;
	},
	toEditOffice: async () =>  {
		window.location = `/TransferTo?target_fuseaction=edit_office`;
	},
	toEditGroup: async (meeting_id, group_id) => {
		window.location = `/TransferTo?target_fuseaction=edit_group_event&meeting_id=${meeting_id}&group_id=${group_id}`;
	}
};

export default intransfer;
